import { queryKey } from 'Shared/const/queryKey';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { useQueries } from '@tanstack/react-query';

import { ViewingPlatform } from 'app/_entities/sns-account';
import { useMemo } from 'react';
import { useSDQuery } from 'viewup-lib/react';
import { PostCampaignStatus } from '../types';

export const useGetNBlogAccounts = () => {
  const { accessToken } = useTokenStore();
  const { data: blogAccounts, isLoading: blogAccountsLoading } = useSDQuery({
    ...queryKey.viewingCommon.accounts,
    enabled: !!accessToken,
    gcTime: 5000,
    select: (data) => {
      return data.filter(
        ({ viewingPlatform, isApproved }) =>
          viewingPlatform === ViewingPlatform.NBLOG && isApproved,
      );
    },
    staleTime: 5000,
  });

  const queries =
    blogAccounts?.map(({ accountUuid }) => ({
      ...queryKey.posting.overviewList({ accountUuid }),
      enabled: !!accountUuid && !!blogAccounts,
      gcTime: 5000,
      staleTime: 5000,
    })) || [];

  const overviewPerAccount = useQueries({
    queries,
  });

  const combine = useMemo(() => {
    if (!blogAccounts) return null;

    const accounts = blogAccounts.map((account, i) => ({
      ...account,
      needSubmission: overviewPerAccount[i].data?.campaigns.filter(
        ({ status }) => status === PostCampaignStatus.APPLY_SUCCESS,
      ).length,
    }));

    return accounts;
  }, [blogAccounts, overviewPerAccount]);

  return {
    data: combine,
    isLoading: blogAccountsLoading || overviewPerAccount.some(({ isLoading }) => isLoading),
  };
};
